import { useMemo } from 'react';
import { INTERAGENCY_CHAT } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from './useHasCapability';

const useIsInteragencyChatEnabled = (): boolean => {
  const interagencyCapabilityEnabled = useHasCapability(INTERAGENCY_CHAT);

  const isInteragencyChatEnabled = useMemo(() => {
    return interagencyCapabilityEnabled.hasCapability ?? false;
  }, [interagencyCapabilityEnabled]);

  return isInteragencyChatEnabled;
};

export default useIsInteragencyChatEnabled;
